// extracted by mini-css-extract-plugin
module.exports = {"productFilter":"filter_sidebar-module__productFilter___3Aw6p","priceHeadline":"filter_sidebar-module__priceHeadline___18TGc"};